<template>
    <Teleport to="body">
      <!-- Modal -->
      <Transition name="modal">
        <div v-if="showPartsVideo" class="modal-mask">
          <div class="modal-container">
            <div class="modal-header">
              <button
                type="button"
                class="btn-close"
                @click="$emit('showModalModelPartsVideo', false)"
                aria-label="Close"
                style="font-size: 25px;"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                    <NavBarPartsVideoMobile :parts="parts" :translate="translate" :videosIndex="videosIndex" @changeResolution="changeResolutionMobile"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>
  </template>
  
  <script lang="ts">
    import { defineComponent } from 'vue'
    import NavBarPartsVideoMobile from '../Model/NavBarPartsVideoMobile.vue'

    export default defineComponent({
      name: 'ModalModelPartsVideo',
      props: ['showPartsVideo', 'parts', 'translate','videosIndex'],
      emits: ['showModalModelPartsVideo', 'changeResolution'],
      components: {
        NavBarPartsVideoMobile
      },
      methods: {
        changeResolutionMobile(val: number){
          this.$emit('changeResolution', val)
          this.$emit('showModalModelPartsVideo', false)
        }
      }
    })
  </script>
  
  <style scoped lang="css">
    .my-album {
        color: #444444;
    }
    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      transition: opacity 0.3s ease;
      overflow-y: auto;    
    }
  
    .modal-container {
      width: 95%;
      margin: auto;
      padding: 20px 10px;
      background-color: #fff;
      border-radius: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
    }
  
    .modal-header {
      align-items: center;
      justify-content: end;
    }
  
    .modal-body {
      margin: 20px 0;
    }
 
    .modal-default-button {
      float: right;
    }
  
    /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */
  
    .modal-enter-from {
      opacity: 0;
    }
  
    .modal-leave-to {
      opacity: 0;
    }
  
    .modal-enter-from .modal-container,
    .modal-leave-to .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
 
  </style>
  